/**
 * @flow
 * @relayHash 91b784f5f89ebe31bcb7b72132bfb7aa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ArticleSelector_viewer$ref = any;
export type ArticleSelector_Refetch_QueryVariables = {|
  search?: ?string
|};
export type ArticleSelector_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ArticleSelector_viewer$ref
  |}
|};
export type ArticleSelector_Refetch_Query = {|
  variables: ArticleSelector_Refetch_QueryVariables,
  response: ArticleSelector_Refetch_QueryResponse,
|};
*/


/*
query ArticleSelector_Refetch_Query(
  $search: String
) {
  viewer {
    ...ArticleSelector_viewer_40zwac
    id
  }
}

fragment ArticleSelector_viewer_40zwac on Viewer {
  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, plainSearch: $search, hidden: false) {
    articles {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ArticleSelector_Refetch_Query",
  "id": null,
  "text": "query ArticleSelector_Refetch_Query(\n  $search: String\n) {\n  viewer {\n    ...ArticleSelector_viewer_40zwac\n    id\n  }\n}\n\nfragment ArticleSelector_viewer_40zwac on Viewer {\n  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, plainSearch: $search, hidden: false) {\n    articles {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ArticleSelector_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ArticleSelector_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "search",
                "variableName": "search",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ArticleSelector_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "articlesForSelector",
            "name": "articlesPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Literal",
                "name": "hidden",
                "value": false,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 5,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "plainSearch",
                "variableName": "search",
                "type": "String"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4d25348e98667a74418f961163ae9573';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/__generated__/ArticleSelector_Refetch_Query.graphql.js